import { useState } from "react";
import { Link } from "wouter";
import PhotoGallery from "@/components/PhotoGallery";
import { projects } from "@/data/projects";

const Projects = () => {
  const categories = [
    { id: "all", name: "Всички" },
    { id: "apartments", name: "Апартаменти" },
    { id: "bathrooms", name: "Бани" },
    { id: "kitchens", name: "Кухни" },
    { id: "terraces", name: "Тераси" },
  ];

  const [activeCategory, setActiveCategory] = useState("all");

  const filteredProjects = activeCategory === "all" 
    ? projects 
    : projects.filter(project => project.category === activeCategory);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-primary">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">Наши проекти</h1>
            <p className="text-xl text-white max-w-2xl mx-auto">
              Разгледайте някои от нашите завършени проекти и се убедете в качеството на нашата работа
            </p>
          </div>
        </div>
      </section>

      {/* Projects Gallery Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Галерия</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Избрани проекти от нашето портфолио, показващи разнообразието и качеството на нашата работа.
            </p>
          </div>
          
          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center mb-10 gap-2">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-4 py-2 rounded-md transition duration-300 ${
                  activeCategory === category.id
                    ? "bg-primary text-white"
                    : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
          
          {/* Project Gallery */}
          <PhotoGallery projects={filteredProjects} />
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-6">Имате подобен проект?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Свържете се с нас, за да обсъдим как можем да реализираме вашите идеи.
          </p>
          <Link href="/contact">
            <button className="bg-[#D95204] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300 text-lg">
              Поискайте оферта
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Projects;
